{
  "nav": {
    "mainNavigation": "التنقل الرئيسي",
    "sectionSettings": "الإعدادات",
    "settings": "الإعدادات",
    "users": "المستخدمين",
    "groups": "المجموعات",
    "reports": "التقارير",
    "changeBranch": "تغيير الفرع",
    "systems": "الأنظمة",
    "toggleSidebarHint": "تبديل الشريط الجانبي",
    "overview": "لمحة عامة",
    "accounts": "عملاء الذمم",
    "trash": "سلة المحذوفات",
    "debtsSettings": "إعدادات الذمم"
  },
  "sidebar": {
    "toggle": "تبديل الشريط الجانبي",
    "toggleHint": "إظهار أو إخفاء القائمة",
    "title": "القائمة الجانبية",
    "description": "التنقل بين صفحات النظام"
  },
  "brand": "المسافر"
}
